import { httpClient } from "../../../../../utils/HttpClient";

const getYoutubeVideosFetch = async () => {
  try {
    const result = await httpClient.get(`home/get-youtube-videos?limit=8`);
    if (result.data.isSuccess) {
      return result.data.formData;
    } else {
      return [];
    }
  } catch (err) {
    // status 404 / network error
    return [];
  }
};

export {
  // get
  getYoutubeVideosFetch,

  // insert

  // update

  // delete
};
